import { Outlet, useLocation } from 'react-router-dom';
import Header from '@/components/Header';
import Spinner from '@/components/Spinner';
import ErrorsModal from '@/components/ErrorsModal';
import DevAuthGuide from '@/components/DevAuthGuide';

/**
 * 원본: .old-gc-mono/apps/gc-zoku/components/apps/UserDashboard.js
 * 메인 레이아웃: Header + Content + Footer + ErrorsModal
 */

const AUTH_PATHS = ['/login', '/bridge/login'];

function App() {
  const location = useLocation();
  const isAuthPage = AUTH_PATHS.some(
    (p) => location.pathname === p || location.pathname.startsWith(p + '/'),
  );

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <Spinner />

      <main className="flex-1 flex flex-col bg-white">
        <Outlet />
      </main>

      {!isAuthPage && (
        <footer className="footer">
          &copy; {new Date().getFullYear()} GC Social Media Marketing, Inc. All Rights Reserved&nbsp;&nbsp;&nbsp;
          <a href="/terms_and_conditions/privacy">Privacy policy</a>
        </footer>
      )}

      <ErrorsModal />
      <DevAuthGuide />
    </div>
  );
}

export default App;
